import React from 'react';

import styles from '../styles.module.css';

interface Props {
  Icon: React.FC;
  balance: string;
  margin?: boolean;
}

export const Balance = ({ Icon, balance, margin }: Props) => {
  const formatted = parseFloat(balance).toLocaleString('en-us', {
    maximumFractionDigits: 2,
    useGrouping: true,
  });

  return (
    <div className={styles.balanceInRow}>
      <Icon />
      <span className={margin ? 'mr-1' : ''}></span>
      {formatted}
    </div>
  );
};
